module.exports = __webpack_public_path__ + "img/25.2a40f4fb.svg";